import AppLayout from "@/layouts/AppLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { MobileUniversityOverview, MobileUniversityNavigation } from "@/components/MobileNavigationLandingPage";
import { useNavigate } from "@/router";
import { useParams } from "react-router-dom";
import { useUniversityNavLinks } from "./_universityNav";
import { useUniversityStaffPermissions } from "@/hooks/useUniversityStaffPermissions";

export default function MobileUniversityLandingPage() {
  const navigate = useNavigate();
  const { universityId } = useParams();
  const { isUniversityStaff } = useUniversityStaffPermissions();
  const navLinks = useUniversityNavLinks(universityId || "");

  if (!universityId) {
    return (
      <AppLayout navLinks={[]} interior bottomBar>
        <Breadcrumb
          compactOnly
          compactTitle="Manage University"
          backLink={{ to: "/education/universities" }}
          onBackClick={!isUniversityStaff ? () => navigate("/education/universities") : undefined}
        />
        <div>University not found</div>
      </AppLayout>
    );
  }

  return (
    <AppLayout navLinks={{ "Manage University": navLinks }} interior bottomBar>
      <Breadcrumb
        compactOnly
        compactTitle="Manage University"
        backLink={{ to: "/education/universities" }}
        onBackClick={!isUniversityStaff ? () => navigate("/education/universities") : undefined}
      />
      <MobileUniversityOverview universityId={universityId} />
      <MobileUniversityNavigation universityId={universityId} />
    </AppLayout>
  );
}
